import { useQuery } from 'react-query';

import { UPLOAD_API_ROUTES } from '@/api-routes/upload';
import { axiosInstance } from '@/axios';

const QUERY_KEY = 'upload-config';

export const useFetchUploadConfig = ({
  source,
  reportType,
}: UseFetchUploadConfigType) => {
  return useQuery(
    [QUERY_KEY, reportType],
    () =>
      axiosInstance.get<ApiResponseType>(UPLOAD_API_ROUTES.baseRoute(), {
        params: {
          source: source,
          report_type: reportType,
        },
      }),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      select: (data) => {
        return data?.data?.config;
      },
    }
  );
};

type ApiResponseType = {
  config: {
    file_size_limit: number;
    file_types: string[];
    file_count_limit: number;
    mime_types?: string[];
  };
};

type UseFetchUploadConfigType = {
  source: string;
  reportType?: string;
};
